export function updateErrors(
  currentErrors: Record<string, boolean>,
  newErrors: Record<string, boolean>,
): Record<string, boolean> {
  Object.entries(newErrors).forEach(([key, value]) => {
    currentErrors[key] = value;
  });
  return currentErrors;
}

export function hasCustomError(errors: Record<string, boolean>): boolean {
  return Object.values(errors).includes(true);
}

export function isErrorWithMessage(value: unknown): value is { message: string } {
  return typeof value === 'object' && value !== null && 'message' in value && typeof value.message === 'string';
}
